import { GlTable, GlLink, GlIcon, GlTruncateText, GlKeysetPagination, GlFilteredSearch, GlLoadingIcon, GlButton, GlButtonGroup, GlCollapsibleListbox, GlTooltipDirective } from '../../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { s__ } from '~/locale';
import { OPERATORS_IS, OPERATORS_OR } from '~/vue_shared/components/filtered_search_bar/constants';
import { SORT_BY_OLDEST_VERSION, SORT_BY_VERSION, SORT_BY_LAST_USED, SORT_BY_PROJECT_NAME, TOKEN_TYPE_COMPONENT, TOKEN_TYPE_VERSION } from '../../constants';
import ComponentNameToken from './tokens/component_name_token.vue?vue3';
import VersionToken from './tokens/version_token.vue?vue3';
const STATUS = {
    outdated: {
        icon: 'warning',
        iconClass: 'gl-text-warning',
        label: s__('CiCatalog|Outdated')
    },
    upToDate: {
        icon: 'status_success',
        iconClass: 'gl-text-success',
        label: s__('CiCatalog|Up to date')
    }
};
export default {
    name: 'UsageDetails',
    components: {
        GlTable,
        GlIcon,
        GlLink,
        GlTruncateText,
        GlKeysetPagination,
        GlFilteredSearch,
        GlLoadingIcon,
        GlButton,
        GlButtonGroup,
        GlCollapsibleListbox
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        componentUsages: {
            type: Array,
            required: true
        },
        pageInfo: {
            type: Object,
            required: true
        },
        resourcePath: {
            type: String,
            required: true
        },
        isLoading: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'next-page',
        'prev-page',
        'filters-changed',
        'sort'
    ],
    data () {
        return {
            filterTokens: [],
            selectedSortOption: SORT_BY_OLDEST_VERSION,
            sortAscending: true
        };
    },
    computed: {
        items () {
            return this.componentUsages.map((item)=>{
                const sortedComponents = this.sortComponents(item.componentsUsed);
                const oldestComponent = sortedComponents[0];
                const versionName = oldestComponent?.version?.name;
                const statusDetails = oldestComponent?.outdated ? STATUS.outdated : STATUS.upToDate;
                const status = oldestComponent ? {
                    versionName,
                    ...statusDetails
                } : null;
                return {
                    project: item.project,
                    status,
                    componentsUsedString: this.formatComponentsList(sortedComponents)
                };
            });
        },
        availableTokens () {
            return [
                {
                    type: TOKEN_TYPE_COMPONENT,
                    title: s__('CiCatalog|Component'),
                    unique: true,
                    token: ComponentNameToken,
                    operators: OPERATORS_IS,
                    resourcePath: this.resourcePath
                },
                {
                    type: TOKEN_TYPE_VERSION,
                    title: s__('CiCatalog|Version'),
                    unique: true,
                    multiSelect: true,
                    token: VersionToken,
                    operators: OPERATORS_OR,
                    resourcePath: this.resourcePath
                }
            ];
        },
        sortIcon () {
            return this.sortAscending ? 'sort-lowest' : 'sort-highest';
        },
        sortDirectionLabel () {
            return this.sortAscending ? s__('CiCatalog|Sort direction: ascending') : s__('CiCatalog|Sort direction: descending');
        },
        sortOrder () {
            return `${this.selectedSortOption}_${this.sortAscending ? 'ASC' : 'DESC'}`;
        }
    },
    watch: {
        sortOrder (newSortOrder) {
            this.$emit('sort', newSortOrder);
        }
    },
    methods: {
        sortComponents (components) {
            return [
                ...components
            ].sort((a, b)=>{
                return a.version.name.localeCompare(b.version.name, undefined, {
                    numeric: true
                });
            });
        },
        formatComponentsList (sortedComponents) {
            return sortedComponents.map((item)=>{
                return `${item.component.name} (${item.version.name})`;
            }).join(', ');
        },
        getFilterValue (filters, type) {
            const filter = filters.find((f)=>f.type === type);
            return filter ? [
                filter.value?.data
            ].flat().filter(Boolean) : [];
        },
        onFilteredSearch (filters = []) {
            this.filterTokens = filters;
            const componentName = this.getFilterValue(filters, TOKEN_TYPE_COMPONENT)[0] || null;
            const versionIds = this.getFilterValue(filters, TOKEN_TYPE_VERSION);
            this.$emit('filters-changed', {
                componentName,
                versionIds
            });
        },
        toggleSortDirection () {
            this.sortAscending = !this.sortAscending;
        },
        onSortSelect (sortOption) {
            this.selectedSortOption = sortOption;
        }
    },
    tableFields: [
        {
            key: 'project',
            label: s__('CiCatalog|Project path'),
            thClass: '@lg/panel:gl-w-3/10'
        },
        {
            key: 'status',
            label: s__('CiCatalog|Status'),
            thClass: '@lg/panel:gl-w-1/5'
        },
        {
            key: 'componentsUsed',
            label: s__('CiCatalog|Components used'),
            thClass: 'gl-text-right',
            tdClass: 'gl-text-right'
        }
    ],
    toggleButtonProps: {
        class: '!gl-text-sm'
    },
    sortOptions: [
        {
            value: SORT_BY_OLDEST_VERSION,
            text: s__('CiCatalog|Oldest version')
        },
        {
            value: SORT_BY_VERSION,
            text: s__('CiCatalog|Newest version')
        },
        {
            value: SORT_BY_LAST_USED,
            text: s__('CiCatalog|Last used')
        },
        {
            value: SORT_BY_PROJECT_NAME,
            text: s__('CiCatalog|Project name')
        }
    ]
};
